
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/concepts",
      function () {
        return require("private-next-pages/mendable-api/concepts.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/concepts"])
      });
    }
  